import React, { useState, useRef } from 'react';
import Label from '../../Form/Label';

interface CopyPasteFieldProps {
  text: string;
  id?: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  description?: string;
  descriptionExplicit?: boolean;
}

export const CopyPasteField = ({ text, id, label, size = 'sm', description, descriptionExplicit }: CopyPasteFieldProps) => {
  const textSizeClass = size === 'lg' ? 'text-base' : size === 'md' ? 'text-sm' : 'text-xs';
  const keyRef = useRef<HTMLInputElement>(null);

  // Copy key
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(text)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="flex flex-col gap-1">
      {label && <Label htmlFor={id} description={description} descriptionExplicit={descriptionExplicit}>{label}</Label>}

      <div className="max-w-md pr-10 w-full px-2.5 relative rounded-md border dark:text-blue-100 dark:bg-blue-900 dark:border-grey-600 bg-grey-100 border-grey-500">
        <div
          id={id}
          ref={keyRef}
          className="w-full pb-0 overflow-x-auto scrollbar-thin scrollbar-track-grey-400/50 scrollbar-thumb-grey-900 scrollbar-thumb-rounded-full scrollbar-track-rounded-full"
        >
          <span className={`block overflow-hidden py-1 w-full whitespace-nowrap ${textSizeClass}`}>{text}</span>
        </div>

        <div className="absolute top-1/2 -translate-y-1/2 right-3  flex items-center gap-2">
          <div className="h-6 dark:bg-grey-600 w-[1px]"></div>
          <button
            className="!text-base material-symbols-outlined dark:text-blue-200"
            onClick={handleCopyClick}
            type="button"
          >
            {isCopied ? 'check' : 'content_copy'}
          </button>
        </div>
      </div>
    </div>
  );
};
